// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PdIo","col":"styles_col__JwyhE"};